import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { populateWorkspaceContent } from '../lib/utils/populate-workspace-content';

export function AuthCallback() {
  const navigate = useNavigate();
  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    const handleAuthRedirect = async () => {
      const params = new URLSearchParams(window.location.search);
      const tokenHash = params.get('token_hash');
      const type = params.get('type');

      if (tokenHash && type) {
        const { error } = await supabase.auth.verifyOtp({
          token_hash: tokenHash,
          type: type as 'signup' | 'recovery' | 'email',
        });
        if (error) {
          console.error('Error verifying OTP:', error.message);
          navigate('/auth', { replace: true });
          return;
        }

        if (type === 'recovery') {
          navigate('/auth/reset', { replace: true });
          return;
        }
      }

      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (!session) {
        navigate('/auth', { replace: true });
        return;
      }

      await populateWorkspaceContent();
      navigate('/agent-builder', { replace: true });
    };

    handleAuthRedirect();
  }, [navigate]);

  return (
    <div className="mt-20 text-center text-gray-600">Authenticating...</div>
  );
}
